<style scoped lang="less">
  @import "../styles/color";

  .message {
    cursor: pointer;
  }

  .iconfont.icon-message1 {
    font-size: 24px;
  }

  .iconfont.online {
    color: @primaryColor;
  }

  .iconfont.no-online {
    color: #ddd;
  }

  .messageButton.offline {
    color: #ddd;
  }
</style>
<template>
  <div :data-type="type">
    <!--    //类型   `type` int(1) DEFAULT NULL COMMENT '0:展商 1:观众 2:展品 3:需求',-->
    <!--    展商-->
    <div>
      <div v-if="type==0">
        <el-popover
          @show="triggerSendMessageOther"
          placement="right"
          width="400"
          trigger="click">
          <!--      gridData 联系人列表-->
          <!--
                createTime: "2020-07-21 19:52:11"
                id: "119"
                job: "1"
                mobile: "18819448261"
                name: "1"
                projectId: "2baf2968-f6e4-48a7-b6c2-59f1c63aa569"
                status: 0
                supplierId: "8fb7b1ee-9bef-40eb-945f-f33daddadd16"
                updateTime: "2020-07-21 19:52:11"
                weixinId: ""-->
          <!--          isOnline  0未在线 1 在线-->
          <el-table :data="contactList" v-loading="loading">
            <el-table-column property="name" :label="$t('lang.名称')"></el-table-column>
            <el-table-column property="操作" :label="$t('lang.操作')">
              <template slot-scope="scope">
                <el-button type="text"
                           :data-online="scope.row.isOnline"
                           class="messageButton"
                           :class="[scope.row.isOnLine==0?'offline':'online']"
                           @click="()=>triggerSendMessage2Contact(scope.row)">{{$t('lang.发消息')}}
                </el-button>
                <!-- :disabled="scope.row.isOnLine==0?true:false" -->
              </template>
            </el-table-column>
          </el-table>
          <div class="message" slot="reference" @click="()=>triggerSendMessageOtherCall()">
            <i class="iconfont icon-message1" :class="[online==1?'online':'no-online']"></i>
          </div>
        </el-popover>
      </div>
      <!-- <div v-else-if="type==0">
        <div class="message" slot="reference" @click="()=>triggerSendMessageOther()">
          <i class="iconfont icon-message1" :class="[online==1?'online':'no-online']"></i>
        </div>
      </div> -->
    </div>


    <!--    观众-->
    <div class="message" slot="reference" v-if="type==1" @click="sendAudience">
      <i class="iconfont icon-message1" :class="[online==1?'online':'no-online']"
      ></i>
    </div>

    <div class="message" slot="reference" v-else-if="type==2" @click="sendExhibit">
      <i class="iconfont icon-message1" :class="[online==1?'online':'no-online']"
      ></i>
    </div>

    <div class="message" slot="reference" v-else-if="type==3" @click="sendDemand">
      <i class="iconfont icon-message1" :class="[online==1?'online':'no-online']"
      ></i>
    </div>


  </div>
</template>
<script>
import bus from '@common/bus'
  import {createProp, getLoginUser, getUserIdByUserRole, params2url, setCookie} from "../../common/utils";
  import {triggerSendMessageOther} from '../../common/utils/imUtils';
  import myalert from "../../common/utils/myalert";
  import ajax from "../../common/utils/ajax";
  import {go2RegisterForm, isComplateUserProfile, isExhibitor} from "../utils";
  import * as routerUtil from "../../common/utils/routerUtil";

  export default {
    data() {
      return {
        loading: false,
        contactList: [],
      }
    },
    props: {
      //类型   `type` int(1) DEFAULT NULL COMMENT '0:展商 1:观众 2:展品 3:需求',
      type: createProp([String, Number]),
      userId: createProp([String, Number]),
      info: createProp([Object]),
      // 不需要对方在线，所以需要开放
      online: createProp([String, Number], {
        default: 0
      }),
      mode: createProp([String, Number]),//mode:new 新的模式渲染界面
    },
    computed: {},
    methods: {
      triggerSendMessage2Contact(one) {
        var user = getLoginUser()
        //没有登录跳转登录
        if (user.id == null || user.id == undefined || user.id == '') {
          myalert.confirm("您未登录，请先登录再操作").then(isyes => {
            if (isyes) {
              routerUtil.push("/login")
              bus.$emit('getonbus',true)
              return false
            }
          })

          return false
        }
        console.log(one,'one')
        if (!isComplateUserProfile()) {
          myalert.fail(`${this.$t('lang.您还没有完善个人信息，请填写完毕后在操作')}`)
          setTimeout(() => {
            go2RegisterForm()
          }, 500)
          return false
        }
        var contactId = one.id || one.supplierId
        setCookie("cache_conversation_conversationID", `C2C${contactId}`)
        var url = ''
        if (isExhibitor()) {
          url = "/pc/me/exhibition/message"
        } else {
          url = "/pc/me/purchaser/message"
        }
        url = `${url}?${params2url({
          from: getLoginUser().id,
          to: contactId,
        })}`
        window.open(url)
      },
      sendAudience() {
        if (this.online != 1) {
          myalert.fail(this.$t('lang.观众未登录'))
          // return false
          setTimeout(() => {
            this.triggerSendMessageOther1.call(this, this.info.id)
          }, 1000);
        } else {
          this.triggerSendMessageOther1.call(this, this.info.id)
        }
      },
      triggerSendMessageOther1(contactId) {
        setCookie("cache_conversation_conversationID", `C2C${contactId}`)
        var url = `/pc/me/purchaser/message?${params2url({
          from: getLoginUser().id,
          to: contactId,
        })}`
        window.open(url)
      },
      sendExhibit() {
        var user = getLoginUser()
        //没有登录跳转登录
        if (user.id == null || user.id == undefined || user.id == '') {
          myalert.confirm("您未登录，请先登录再操作").then(isyes => {
            if (isyes) {
              routerUtil.push("/login")
              bus.$emit('getonbus',true)
              return false
            }
          })

          return false
        }
        if (this.online != 1) {
          myalert.fail(this.$t('lang.展商未登录'))
          // return false
          setTimeout(() => {
            this.triggerSendMessageOther1.call(this, this.info.supplierId)
          }, 1000);
        } else {
          this.triggerSendMessageOther1.call(this, this.info.supplierId)
        }
        
      },
      sendDemand() {
        var user = getLoginUser()
        //没有登录跳转登录
        if (user.id == null || user.id == undefined || user.id == '') {
          myalert.confirm("您未登录，请先登录再操作").then(isyes => {
            if (isyes) {
              routerUtil.push("/login")
              bus.$emit('getonbus',true)
              return false
            }
          })

          return false
        }
        if (this.online != 1) {
          myalert.fail(this.$t('lang.观众未登录'))
          // return false
          setTimeout(() => {
            this.triggerSendMessageOther1.call(this, this.info.purchaserId)
          }, 1000);
        } else{
          this.triggerSendMessageOther1.call(this, this.info.purchaserId)
        }
      },
      triggerSendMessageOtherCall(one) {
        if (!isComplateUserProfile()) {
          myalert.fail(`${this.$t('lang.您还没有完善个人信息，请填写完毕后在操作')}`)
          setTimeout(() => {
            go2RegisterForm()
          }, 500)
          return false
        }

        if (one) {
          this.triggerSendMessageOther1.call(this, one.id || one.supplierId)
        }
      },
      //展商
      triggerSendMessageOther() {
        console.log(this.info)
        if (this.online != 1) {
          myalert.fail(this.$t('lang.展商未登录'))
          // return false
        }
        var toid = getUserIdByUserRole(this.info);
        this.loading = true
        var self = this;
        this.ajaxContactList().then(res => {
          console.log(res)
          this.loading = false
          this.contactList = res
          if (!this.contactList || this.contactList.length <= 0) {
            this.triggerSendMessageOther1.call(self, self.info.id || self.info.supplierId)
          // } else{
          //   this.triggerSendMessageOther1.call(self, self.info.id || self.info.supplierId)
          }
        }).catch(e => {
          console.error("this.ajaxContactList ", e)
          this.loading = false
        })
      },
      async ajaxContactList() {
        var toid = getUserIdByUserRole(this.info);
        var result = await ajax.get(`/api3/suppliercontact/${toid}/getAllSupplierContact?current=1&size=99`).then(res => res.data)
        return result && result.result && result.result.list
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/wenxing/components/messageButton.vue